import { Trans, useTranslation } from 'next-i18next';

import GMap from '@/components/GMap/dynamic';
import { Button } from '@/components/shared/Button';
import { Icons, IconsTypes } from '@/components/shared/Icons';
import { Link } from '@/components/shared/Link';
import { COMMON_LOCALE_PART } from '@/locale';
import { Colors } from '@/types';

export function VisitInfo() {
  const { t } = useTranslation(COMMON_LOCALE_PART);

  return (
    <section className="bg-white pb-2.5 md:pb-24 md:pt-8 lg:pt-9">
      <div className="container flex columns-2 flex-col pt-7 lg:max-h-[690px] lg:flex-col lg:flex-wrap">
        <div className="order-1 w-full lg:w-1/2 lg:pr-20">
          <h2 className="mb-6 md:mb-0 md:hidden">{t('visitors-information.heading')}</h2>
          <h3 className="mb-1.5 md:mb-2.5">{t('visitors-information.about-us.title')}</h3>
          <p className="mb-6">{t('visitors-information.about-us.description')}</p>
          <div className="mb-8 flex justify-start gap-2.5 md:mb-12 md:gap-6">
            <Link href="/page/about-us">
              <Button variant={Colors.secondary} type="button">
                {t('buttons.read-more')}
              </Button>
            </Link>

            <Link href="/page/plan-your-visit">
              <Button type="button">{t('buttons.plan-visit')}</Button>
            </Link>
          </div>
          <div className="mb-6 flex gap-5 md:mb-8">
            <div className="w-1/2">
              <h3 className="mb-0 md:mb-2 lg:mb-4">{t('shared.location.title')}</h3>
              <div className="inline-flex gap-6 md:gap-3">
                <span className="mt-2">
                  <Icons name={IconsTypes.PIN} />
                </span>
                <p className="md:text-base-md">{t('shared.location.address')}</p>
              </div>
            </div>
            <div className="w-1/2">
              <h3 className="mb-0 md:mb-2 lg:mb-4">{t('shared.schedule.title')}</h3>
              <div className="inline-flex gap-3">
                <span className="mt-2">
                  <Icons name={IconsTypes.CLOCK} />
                </span>
                <p className="md:text-base-md">
                  <Trans i18nKey="shared.schedule.time" />
                </p>
              </div>
            </div>
          </div>

          <Link href={'/page/plan-your-visit#route'}>
            <Button type="button">{t('buttons.route')}</Button>
          </Link>
        </div>

        <div className="order-2 mx-auto flex w-full flex-row justify-start pb-9 pt-9 md:order-3 md:pb-0 lg:mx-0 lg:w-1/2 lg:justify-end lg:pb-0 lg:pt-0">
          <GMap markerTitle={t('shared.location.marker-title')} />
        </div>

        <div className="order-3 mt-0 w-full md:order-2 md:mt-9 lg:mt-14 lg:w-1/2 lg:break-before-column lg:pr-20">
          <h3 className="mb-2.5 md:mb-3.5">{t('visitors-information.rules.title')}</h3>
          <p className="flex">
            {t('visitors-information.rules.description')}
            <Link href="/page/rules-of-conduct" className="ml-2 flex items-center text-green">
              <span className="mr-2">{t('visitors-information.rules.link')}</span>
              {Icons({ name: IconsTypes.ARROW_RIGHT })}
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
}
